import { useMediaQuery } from "@mui/material";
import { widthHeightType } from "../../icons/components/type.types";

type dimensionType = {
  xs: boolean;
  md: boolean;
  lg?: boolean;
  width: widthHeightType;
  height: widthHeightType;
};
const calcDimension = ({ xs, md, lg, width, height }: dimensionType) => {
  let iconWidth;
  let iconHeight;
  if (xs) {
    iconWidth = width.xs;
    iconHeight = height.xs;
  } else if (md) {
    iconWidth = width.md || width.xs;
    iconHeight = height.md || height.xs;
  } else if (lg) {
    iconWidth = width.lg || width.md || width.xs;
    iconHeight = height.lg || height.md || height.xs;
  } else {
    iconWidth = width.xl || width.lg || width.md || width.xs;
    iconHeight = height.xl || height.lg || height.md || height.xs;
  }

  return [
    parseFloat(iconHeight) * 16 + "px",
    parseFloat(iconWidth) * 16 + "px",
  ];
};
export default function useIcon({
  width,
  height,
}: {
  width: widthHeightType;
  height: widthHeightType;
}) {
  const xs = useMediaQuery("(max-width:600px)");
  const md = useMediaQuery("(max-width:900px)");
  const lg = useMediaQuery("(max-width:1520px)");
  const [iconWidth, iconHeight] = calcDimension({ xs, lg, md, width, height });
  return [iconWidth, iconHeight];
}
